<!-- 专题管理编辑页 -->
<template>
  <div class="page-module-wrap">
    <div class="tile is-parent">
      <article class="tile is-child box">
        <div class="section-gap">
            <div class="block">
              <div class="control">
                <label class="label inline-block r-top">专题ID：</label>
                <div class="inline-block">
                  <input class="input width-2" @change="onSearch()" type="text" v-model="params.topicId">
                </div>
                <span>请填写-穿衣-专题管理-专题列表中的专题Id</span>
              </div>
            </div>
            <div class="block">
                <label class="label inline-block r-top">标题：</label>
                <span class='limit-input'><limit-input :value.sync='params.title' :limit-number='18' :placeholder='"请输入标题"'></limit-input></span>
                <el-checkbox style="margin-left: 20px;padding-top: 5px" v-model="params.isShowTitle">显示标题</el-checkbox>
            </div>
            <div class="block">
                <label class="label inline-block r-top">标题描述：</label>
                <input style="width: 80%;" class="input " type="text" v-model="params.description">
            </div>

            <div class="block">
              <div class="control">
                <label class="label inline-block r-top">显示状态：</label>
                <div class="inline-block">
                  <span class="radio r-top">
                    <input type="radio" id="good" name="shopProp" value="1" v-model="status" >
                    <label for="good">永久开启</label>
                  </span>
                  <span class="radio r-top">
                    <input type="radio" id="suit" name="shopProp" value="0" v-model="status" >
                    <label for="suit">永久关闭</label>
                  </span>
                  <span class="radio r-top">
                    <input type="radio" id="suit" name="shopProp" value="2" v-model="status" >
                    <label for="suit">定时开关</label>
                  </span>
                </div>
              </div>
            </div>
            <div class="block" v-if="status === 2 || status === '2'">
              <div class="control">
                <p class="inline-block width-3">
                  <el-date-picker
                    v-model="datetimerange"
                    type="datetimerange"
                    placeholder="请选择时间">
                  </el-date-picker>
                </p>
              </div>
            </div>
            <div class="block">
              <div class="control">
                <label class="label inline-block r-top">封面图：</label>
                <div class="block">
                  <span class="button is-primary" id="js_imageUploadBtn" style="line-height: 30px;">上传图片</span>
                  <span class="picText">建议尺寸：480*640px</span><span style="margin-left: 20px; line-height 32px;">只能上传 jpg/png 文件，且不超过1MB</span>
                </div>
                <div class="block">
                  <image-component v-if="params.image.image" :image="params.image" :width="600"></image-component>
                </div>
              </div>
            </div>
            <div class="inline-block">
              <p>
                <span class="button is-info" @click="onSaveTopic">保存</span>
                <span class="button" @click="backClick">返回</span>
              </p>
            </div>
        </div>
      </article>
    </div>
  </div>
</template>

<script type="text/babel">
import Uploader from 'COMMON/uploaderModule/uploader'
import { formatDate } from 'UTILS/date'
import LimitInput from 'COMMON/limitInput'

export default {
  components: {
    LimitInput
  },
  data () {
    return {
      datetimerange: [],
      status: '',
      type: '',
      requestImg: [],
      topicAdId: 0,
      params: {
        image: {
          image: '',
          width: 0,
          height: 0
        },
        title: '',
        description: '',
        topicId: '',
        status: '',
        startTime: '',
        endTime: '',
        isShowTitle: 0
      }
    }
  },
  mounted () {
    this.topicAdId = this.$route.query.topicId
    this.type = this.$route.query.operationType
    this.uploadMainBind()
    if (this.type === 'edit') {
      this.getSingleTopic()
    }
  },

  methods: {
    formatDate (date) {
      return formatDate(date, 'yyyy-MM-dd hh:mm:ss')
    },
    uploadMainBind () {
      // 绑定上传图片控件
      let params = {
        config: {
          pick: {
            id: '#js_imageUploadBtn',
            multiple: false
          },
          server: process.env.VUE_APP_PLATFORM + '/admin.php?method=image.uploadImage',
          fileVal: 'image',
          fileSizeLimit: 1 * 1024 * 1024,
          fileSingleSizeLimit: 1 * 1024 * 1024
        },
        extensionField: {
          target: this
        },
        events: {
          onFilesQueued (files, uploaderObj) {
            return this.onFilesQueued && this.onFilesQueued(files, uploaderObj)
          },
          onSuccess (response, file, uploaderObj) {
            this.params.image.image = response.data.images.info.path
            this.params.image.width = response.data.images.info.width
            this.params.image.height = response.data.images.info.height
          },
          onError (response, file, uploaderObj) {

          }
        }
      }
      new Uploader(params)
    },
    getSingleTopic () {
      let params = {
        adId: this.topicAdId
      }
      HttpRequest.get('/admin.php?method=main.getTopicAd', params).then(response => {
        if (response && response.result === 0) {
          this.params = response.data
          this.params.isShowTitle = !!this.params.isShowTitle
          this.status = response.data.status
          if (response.data.status === 1 && response.data.startTime > 0 && response.data.endTime > 0) {
            this.status = '2'
          }
          this.datetimerange.push(this.formatDate(response.data.startTime, 'yyyy-MM-dd hh:mm:ss'))
          this.datetimerange.push(this.formatDate(response.data.endTime, 'yyyy-MM-dd hh:mm:ss'))
        }
      })
    },

    /**
       * 保存
       * 提交
       */
    onSaveTopic () {
      this.params.status = this.status
      let params = Object.assign({}, this.params)

      if (parseInt(this.status) !== 2) {
        params.startTime = 0
        params.endTime = 0
      } else {
        params.startTime = this.datetimerange[0]
        params.endTime = this.datetimerange[1]
      }
      if (parseInt(this.status) === 2) {
        params.status = 1
      }
      params.adId = this.topicAdId && this.topicAdId || ''
      params.isShowTitle = params.isShowTitle ? 1 : 0
      params.startTime = params.startTime ? Date.parse(params.startTime) / 1000 : params.startTime
      params.endTime = params.endTime ? Date.parse(params.endTime) / 1000 : params.endTime
      HttpRequest.post('/admin.php?method=main.doSaveTopicAd', params, true).then(response => {
        if (response.data.success == 1) {
          this.$message('保存成功')
          setTimeout(() => {
            this.$router.push({
              name: 'cyzsIndexTopic',
              query: {
                page: this.$route.query.page
              }
            })
          }, 2000)
        } else {
          this.$message('接口错误,请联系管理员')
        }
      })
    },
    backClick () {
      this.$router.push({
        name: 'cyzsIndexTopic',
        query: {
          page: this.$route.query.page
        }
      })
    },
    onSearch () {
      let params = {
        topicId: this.params.topicId
      }
      HttpRequest.get('/admin.php?method=blogger.getTopic', params).then(response => {
        this.params.title = response.data.name
        this.params.description = response.data.description
        this.params.image = response.data.banner
      })
    }
  }
}
</script>

<style rel="stylesheet/less" lang="less" scoped>
  .page-module-wrap{
    td{
      span{
        word-break: break-all;
      }
    }
    p{
      word-break: break-all;
    }
    .clearfix:after {
      content: ".";
      display: block;
      height: 0;
      clear: both;
      visibility: hidden;
    }

    .clearfix {
      _overflow: hidden;
    }
    .fleft{
      float: left;
    }
    .fright{
      float: right;
    }
    .red{
      color:red;
    }
    .green{
      color:green;
    }
    .margin-top {
      margin-top: 10px;
    }
    .margin-left {
      margin-left: 40px;
    }
    .width-2 {
      width: 150px;
    }
    .width-3{
      width: 200px;
      input{
        width:180px;
      }
    }
    .inline-block {
      display: inline-block;
    }
    .vertical-middle {
      vertical-align: middle;
    }

    .title {
      font-size: 16px;
      height: 25px;
      line-height: 16px;
      padding-left: 6px;
      padding-right: 6px;
      font-weight: bold;
    }

    .control {
      display: inline-block;
      margin-right: 20px;
    }
    .margin-left1{
      margin-left: 20px;
    }
    .r-top {
      position: relative;
      top: 5px;
    }
    .danger{
      background-color: #ed6c63;
      border-color: transparent;
      color: white;
    }

    .section-gap{
      border-bottom: 1px dashed #666;
      padding-bottom: 15px;
      margin-bottom: 20px;
    }
    .list-wrap{
      padding-bottom: 40px;
      .order-item{
        margin-bottom: 30px;
        .img-goods{
          width:90%;
        }
      }
      .goods-img {
        min-width: 70px;
      }
    }
    .data-isnull {
      display: inline-block;
      width: 100%;
      font-size: 25px;
      color:#ccc;
      text-align: center;
    }
    .picText {
      color: #ff0000;
      margin-left: 20px;
      line-height: 32px;
    }
    .limit-input {
      display: inline-block;
      width: 400px;
      vertical-align: top;
    }
  }

</style>
